import { Action } from 'infra/types'
import { IBusinessSettingsResponse } from 'services/Api/BillingApiFolder.ts/type'
import { TImageBackupDestination } from 'services/ImageBackup/ImageBackupPreference'
import { IGoogleDriveState, ISettingsState } from 'state/settings/settings.types'

export const SettingsAction = {
  SET_SETTINGS_DRAWER: 'settings/SET_SETTINGS_DRAWER',
  SET_SETTINGS_LOADERS: 'settings/SET_SETTINGS_LOADERS',
  FETCH_OVERALL_BUSINESS_SETTINGS: 'settings/FETCH_OVERALL_BUSINESS_SETTINGS',
  FETCH_OVERALL_BUSINESS_SETTINGS_SUCCESS: 'settings/FETCH_OVERALL_BUSINESS_SETTINGS_SUCCESS',
  UPDATE_BUSINESS_SETTINGS_ACTION: 'settings/UPDATE_BUSINESS_SETTINGS_ACTION',
  RESET_LOADERS: 'settings/RESET_LOADERS',
  TRACK_STAFF_LOCATION: 'settings/TRACK_STAFF_LOCATION',
  TRACK_STAFF_LOCATION_TRAVELLED: 'settings/TRACK_STAFF_LOCATION_TRAVELLED',
  SET_STAFF_LOCATION_TRAVELLED: 'settings/SET_STAFF_LOCATION_TRAVELLED',
  FETCH_GDRIVE_STATUS: 'settings/FETCH_GDRIVE_STATUS',
  SET_GDRIVE_STATUS: 'settings/SET_GDRIVE_STATUS',
  SET_GDRIVE_LOADING: 'settings/SET_GDRIVE_LOADING',
  SET_GDRIVE_SYNCING: 'settings/SET_GDRIVE_SYNCING',
  BACKUP_GDRIVE_NOW: 'settings/BACKUP_GDRIVE_NOW',
  UPDATE_IMAGE_BACKUP_DESTINATION: 'settings/UPDATE_IMAGE_BACKUP_DESTINATION'
}

export const setSettingsDrawerAction = (payload: {
  id: keyof ISettingsState['drawers']
  value: boolean
}): Action<{
  id: keyof ISettingsState['drawers']
  value: boolean
}> => ({
  type: SettingsAction.SET_SETTINGS_DRAWER,
  payload
})

export const setSettingsLoaderAction = (payload: {
  loaderName: keyof ISettingsState['loaders']
  status: boolean
}): Action<{
  loaderName: keyof ISettingsState['loaders']
  status: boolean
}> => ({
  type: SettingsAction.SET_SETTINGS_LOADERS,
  payload
})

export const fetchOverallBusinessSettingsAction = (): Action<null> => ({
  type: SettingsAction.FETCH_OVERALL_BUSINESS_SETTINGS,
  payload: null
})

export const fetchOverallBusinessSettingsSuccessAction = (
  payload: IBusinessSettingsResponse
): Action<IBusinessSettingsResponse> => ({
  type: SettingsAction.FETCH_OVERALL_BUSINESS_SETTINGS_SUCCESS,
  payload
})

export const updateBusinessSettingsAction = (payload: {
  id: string
  value: boolean
}): Action<{ id: string; value: boolean }> => ({
  type: SettingsAction.UPDATE_BUSINESS_SETTINGS_ACTION,
  payload
})

export const resetSettingsLoaders = (): Action<null> => ({
  type: SettingsAction.RESET_LOADERS,
  payload: null
})

export const trackStaffLocationAction = (staffId: string): Action<string> => ({
  type: SettingsAction.TRACK_STAFF_LOCATION,
  payload: staffId
})

export const calculateStaffsDistanceTravelled = (staffId: string): Action<string> => ({
  type: SettingsAction.TRACK_STAFF_LOCATION_TRAVELLED,
  payload: staffId
})

export const setStaffDistanceTravelled = (payload: { staffId: string; distance: number }) => ({
  type: SettingsAction.SET_STAFF_LOCATION_TRAVELLED,
  payload
})

export const fetchGoogleDriveStatusAction = (): Action<null> => ({
  type: SettingsAction.FETCH_GDRIVE_STATUS,
  payload: null
})

export const setGoogleDriveStatusAction = (
  payload: Partial<IGoogleDriveState>
): Action<Partial<IGoogleDriveState>> => ({
  type: SettingsAction.SET_GDRIVE_STATUS,
  payload
})

export const setGoogleDriveLoadingAction = (payload: boolean): Action<boolean> => ({
  type: SettingsAction.SET_GDRIVE_LOADING,
  payload
})

export const setGoogleDriveSyncingAction = (payload: boolean): Action<boolean> => ({
  type: SettingsAction.SET_GDRIVE_SYNCING,
  payload
})

export const backupGoogleDriveNowAction = (): Action<null> => ({
  type: SettingsAction.BACKUP_GDRIVE_NOW,
  payload: null
})

export const updateImageBackupDestinationAction = (
  payload: TImageBackupDestination
): Action<TImageBackupDestination> => ({
  type: SettingsAction.UPDATE_IMAGE_BACKUP_DESTINATION,
  payload
})
